module.exports = __webpack_public_path__ + "static/media/arb.2ca8d1c1.png";